<template>
	<div class="file">

		<p v-if="model">{{model.name}}</p>
		<el-button 
		v-else
		type="text" 
		size="mini"
		@click="uploadFile">
			Subir archivo <i class="el-icon-upload el-icon-right"></i>
		</el-button>

		<input
		type="file"
		ref="file"
		@change="handleFile" />

	</div>
</template>

<script>
	export default {

		name: 'File',
		props: {
			value: [File,String],
			active: Boolean
		},
		data () {
			return {
				model: ''
			}
		},
		watch: {
			model (val) {

				console.log('watch model file: ',val)

				this.$emit('input', val)

				this.$emit('change',val)

			},
			active (val) {
				console.log('watch file active: ',val)
				if (val == false) {
					this.model = ''
				}
			}
		},
		methods: {
			uploadFile() {
				this.$refs.file.value = ''
				this.$refs.file.click()
			},
			handleFile(e) {
				console.log('handleFile', e.target.files[0])
				this.model = this.$refs.file.files[0]
			}
		}
	}
</script>

<style lang="scss">
	.file {
		input {
			display: none;
		}
	}
</style>
